import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbPopup } from "abreact/incubator/ui/popup/AbPopup";
import { PopupPosition } from "abreact/incubator/ui/popup/PopupPosition";
import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbButton } from "abreact/misc/AbButton";
import * as AbHooks from "abreact/utils/AbHooks";
import { ClipboardUtils } from "abweb/utils/clipboard/ClipboardUtils";
import * as React from "react";
const staticPositioner = {
  current: null
};

/**
 * Button wrapper that has default icon, label, and copy to clipboard functionality.
 */
export const AbCopyButton = props => {
  const positioner = staticPositioner.current ?? PopupUtils.createVerticalPositioner({
    spacing: 4
  });
  staticPositioner.current = positioner;
  const [justCopied, setJustCopied] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const buttonRef = React.useRef(null);
  const timeoutRef = React.useRef();
  const safeTimeout = AbHooks.useSafeTimeout();
  const copyText = s => {
    clearTimeout(timeoutRef.current);
    ClipboardUtils.simpleCopyToSystemClipboard(s);
    setJustCopied(true);
    timeoutRef.current = safeTimeout(() => setJustCopied(false), 1000);
  };
  const onClick = event => {
    props.onClick?.(event);
    if (typeof props.copyText === "string") {
      copyText(props.copyText);
      return;
    }
    setBusy(true);
    props.copyText().then(s => {
      copyText(s);
    }).finally(() => {
      setBusy(false);
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AbButton, _extends({}, props, {
    className: ReactUtils.classNamesString([props.className, "ab-copy-button"]),
    tooltip: justCopied ? undefined : props.tooltip,
    busy: busy || props.busy,
    abRef: buttonRef,
    onClick: onClick,
    icon: props.icon ?? "absdk:copy",
    label: props.showLabel ? props.label ?? AbReactResources.abCopyButton_label() : undefined
  })), justCopied && /*#__PURE__*/React.createElement(AbPopup, {
    className: "ab-tooltip",
    modal: false,
    position: PopupPosition.BELOW,
    origin: buttonRef.current ?? undefined,
    resizable: false,
    draggable: false,
    flushContent: true,
    positioner: positioner,
    onClose: () => setJustCopied(false)
  }, /*#__PURE__*/React.createElement("div", {
    className: "ab-tooltip-content"
  }, AbReactResources.abCopyButton_copied())));
};
//# sourceMappingURL=AbCopyButton.js.map
